import { CSIsLoggedIn as IS_LOGGED_IN } from '@admiin-com/ds-graphql';
import { gql, useQuery } from '@apollo/client';
import { useMemo } from 'react';

export const useIsLoggedIn = () => {
  const { data: loggedInData } = useQuery(gql(IS_LOGGED_IN));
  return useMemo(
    () => ({
      isLoggedIn: loggedInData?.isLoggedIn || false,
    }),
    [loggedInData]
  );
};
